const light = '#fff';
const grey = '#d7dfe1';
const dark = '#000';
const disabledColor = '#ccc';
const backgroundColor = '#fff';

let primaryColor = '#b80e80';
let primaryColorLight = '#d7dfe1';
let secondaryColor = '#d3da3d';
let tertiaryColor = '#b80e80';
let bodyColor = '#00394a';
let titleColor = primaryColor;
let menuColor = primaryColor;
let footerColor = 'inherit';
let footerLinkColor = primaryColor;
let footerBackgroundColor = 'transparent';


export {
  light,
  grey,
  dark,
  disabledColor,
  backgroundColor,
  primaryColor,
  primaryColorLight,
  secondaryColor,
  tertiaryColor,
  bodyColor,
  titleColor,
  menuColor,
  footerColor,
  footerLinkColor,
  footerBackgroundColor,
};



// WEBPACK FOOTER //
// ./src/helpers/colors.js